import {FC, PropsWithChildren} from "react";
import {StatusUiProps} from "./StatusUiProps";

// prettier-ignore
export interface StatusIndicatorProps
    extends StatusUiProps {
  status: "loading" | "failure";
}

export const StatusIndicator: FC<PropsWithChildren<StatusIndicatorProps>> = ({
  scriptId,
  status,
  children,
  className
}) => {
  const classes = `script-status script-status--${status}${
    className ? ` ${className}` : ""
  }`;
  return (
    <div
      id={`script-status-${scriptId}`}
      data-testid={`script-status-${scriptId}`}
      className={classes}>
      {children}
    </div>
  );
};
